import { render } from "./PaymentMethodPanel.vue?vue&type=template&id=ec4fbee8&scoped=true"
import script from "./PaymentMethodPanel.vue?vue&type=script&lang=js"
export * from "./PaymentMethodPanel.vue?vue&type=script&lang=js"

import "./PaymentMethodPanel.vue?vue&type=style&index=0&id=ec4fbee8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec4fbee8"]])

export default __exports__